import React from 'react';
import PropTypes from 'prop-types';
import { StyledInput } from '../components/Input.styles';

const Input = ({
    type,
    value,
    onChange,
    placeholder,
    style,
    isError,
    isFilled,
    isDisabled,
    ...props
}) => {
    return (
        <StyledInput
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={style}
            isError={isError}
            isFilled={isFilled}
            disabled={isDisabled}
            {...props}
        />
    );
};

Input.propTypes = {
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    isError: PropTypes.bool,
    isFilled: PropTypes.bool,
    isDisabled: PropTypes.bool,
};

Input.defaultProps = {
    type: 'text',
    placeholder: '',
    style: {},
    isError: false,
    isFilled: false,
    isDisabled: false,
};

export default Input;
